import { BoxTitles } from "@boxes/BoxTitles";
import { BoxTypes } from "@boxes/BoxTypes";
import React from "react";
import { EmailCreativeActionForm } from "../actions/EmailCreativeActionForm";
import { PushCreativeActionForm } from "../actions/PushCreativeActionForm";
import { SmsCreativeActionForm } from "../actions/SmsCreativeActionForm";
import { WhatsAppCreativeActionForm } from "../actions/WhatsAppCreativeActionForm";

export class CreativeGroupActionForm extends React.Component {
  state = {
    selectedCreative: null,
  };

  componentDidMount() {
    const { node } = this.props;
    this.setState({
      selectedCreative: node.data?.creatives?.find((f) => f.selected),
    });
  }

  componentDidUpdate(prevProps) {
    const { visible, node } = this.props;
    if (!prevProps.visible && visible) {
      this.setState({
        selectedCreative: node.data?.creatives?.find((f) => f.selected),
      });
    }
  }

  onChangeCreative(creative) {
    const { node, onChange } = this.props;

    for (const f of node.data?.creatives) {
      if (f.selected) {
        f.data = creative.data;
      }
    }
    onChange && onChange(node);
    this.setState({ selectedCreative: creative });
  }

  saveGroup(creative, close) {
    const { node, onSave } = this.props;

    for (const f of node.data?.creatives) {
      if (f.selected) {
        f.data = creative.data;
      }
    }
    onSave && onSave(node, close);
  }

  render() {
    const { visible, onClose, flowType } = this.props;
    const { selectedCreative } = this.state;

    const props = {
      title: selectedCreative?.type && BoxTitles[selectedCreative.type],
      flowType: flowType,
      visible: visible,
      onClose: onClose,
      node: selectedCreative,
      onChange: (n) => this.onChangeCreative(n),
      onSave: (n, close) => this.saveGroup(n, close),
    };

    switch (selectedCreative?.type) {
      case BoxTypes.SmsCreativeAction:
        return <SmsCreativeActionForm {...props} />;
      case BoxTypes.PushCreativeAction:
        return <PushCreativeActionForm {...props} />;
      case BoxTypes.EmailCreativeAction:
        return <EmailCreativeActionForm {...props} />;
      case BoxTypes.WhatsAppCreativeAction:
        return <WhatsAppCreativeActionForm {...props} />;
      default:
        return null;
    }
  }
}
